import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';
import { motion } from 'framer-motion';
import { ChartBar, Car, UsersThree, Star, Gauge, SignOut, CaretRight, ChartLine } from '@phosphor-icons/react';

function AdminSidebar() {
  const { logout } = useAuth();
  const location = useLocation();
  const links = [
    { label: 'Dashboard', path: '/admin/dashboard', icon: Gauge },
    { label: 'Reservations', path: '/admin/reservations', icon: Car },
    { label: 'Utilisateurs', path: '/admin/utilisateurs', icon: UsersThree },
    { label: 'Avis', path: '/admin/avis', icon: Star },
    { label: 'Vehicules', path: '/admin/vehicules', icon: ChartBar },
    { label: 'Analytics', path: '/admin/analytics', icon: ChartLine },
  ];
  return (
    <aside className="w-full lg:w-64 shrink-0" data-testid="admin-sidebar">
      <div className="bg-desti-surface border border-white/5 p-6">
        <p className="text-xs uppercase tracking-[0.2em] text-desti-gold mb-4">Administration</p>
        <nav className="space-y-1">
          {links.map(l => (
            <Link key={l.path} to={l.path}
              className={`flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${location.pathname === l.path ? 'text-desti-gold bg-desti-gold/5' : 'text-white/60 hover:text-white'}`}
              data-testid={`admin-nav-${l.path.split('/').pop()}`}>
              <l.icon size={18} weight="duotone" /> {l.label}
            </Link>
          ))}
          <div className="line-gold my-3" />
          <Link to="/espace-membre/dashboard" className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/40 hover:text-white transition-colors">
            <CaretRight size={14} /> Espace membre
          </Link>
          <button onClick={logout} className="flex items-center gap-3 px-3 py-2.5 text-sm text-white/40 hover:text-white transition-colors w-full">
            <SignOut size={18} /> Deconnexion
          </button>
        </nav>
      </div>
    </aside>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-20 min-h-screen" data-testid="admin-dashboard-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          <AdminSidebar />
          <div className="flex-1">
            <h1 className="font-heading text-3xl text-white mb-8">Dashboard Admin</h1>
            {stats && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                  { label: 'Total reservations', value: stats.totalBookings, color: 'text-blue-400' },
                  { label: 'CA du mois', value: `${stats.monthlyRevenue.toFixed(2)} EUR`, color: 'text-desti-gold' },
                  { label: 'En attente', value: stats.pendingBookings, color: 'text-yellow-400' },
                  { label: 'Avis a moderer', value: stats.pendingReviews, color: 'text-orange-400' },
                  { label: 'Utilisateurs', value: stats.totalUsers, color: 'text-green-400' },
                ].map((s, i) => (
                  <motion.div key={s.label} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
                    className="bg-desti-surface border border-white/5 p-6" data-testid={`admin-stat-${i}`}>
                    <p className="text-xs text-desti-text uppercase tracking-wide">{s.label}</p>
                    <p className={`text-2xl font-heading mt-2 ${s.color}`}>{s.value}</p>
                  </motion.div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export { AdminSidebar };
